<template lang="pug">
.send-document-pdf-select-modal
  b-modal(v-model="_value" size="md" no-close-on-backdrop no-close-on-esc)
    template(#modal-title)
      span PDF出力形式の選択

    .send-document-pdf-select-modal-body
      .form-group
        label.form-label.font-weight-bold.mb-2 出力形式を選択してください
        select.form-control.input-select(v-model="outputType")
          option(value="list") 一覧表のみ
          option(value="detail") 一覧表＋添付文書画像

      .description-box.mt-3
        label.form-label.font-weight-bold.mb-2 説明
        .description-text(v-if="outputType === 'list'")
          p.mb-0 対象者の履歴のみを出力します。
        .description-text(v-if="outputType === 'detail'")
          p.mb-1 履歴に加えて、添付文書の1ページ目の画像をつけて出力します。
          p.error-message.mb-0 ※添付文書をつけるとダウンロードに時間がかかる場合がございます。

    template(#modal-footer="{ ok, cancel }")
      .buttons.d-flex.justify-content-end
        button.btn.modal-ok-btn(type="button" @click="onSubmit") ダウンロード
        button.btn.modal-cancel-btn(type="button" @click="onCancel") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 文書送付 PDF出力形式選択モーダル
 */
@Component
export default class SendDocumentPdfSelectModal extends Vue {
  @Prop({ required: true })
  value!: boolean;

  /** 出力形式選択（一覧: "list"、詳細: "detail"） */
  outputType: "list" | "detail" = "list";

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
  }

  public onSubmit(): void {
    this.$emit("submit", this.outputType);
    this._value = false;
  }

  public onCancel(): void {
    this._value = false;
  }
}
</script>

<style lang="scss" scoped>
.send-document-pdf-select-modal-body {
  padding: 15px;
}
.modal-ok-btn {
  width: 140px;
}
</style>
